import { useModal } from '@/context/modal'
import { BookMultipleSessionsSection } from '@/shared/api-generated-types'
import BookingConfirmation from '@/widgets/BookingConfirmation'
import Modal from '@/widgets/Modal'
import MultiSessionsBooking from '@/widgets/MultiSessionsBooking'
import { useState } from 'react'
import * as styles from './style'

export interface Props extends BookMultipleSessionsSection {}

const BookMultipleSessionsBlock = (props: Props): JSX.Element => {
  const {
    state: { isOpen },
    dispatch,
  } = useModal()
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  function toggle(): void {
    dispatch({ type: 'TOGGLE' })
  }

  return (
    <Modal className={styles.modal} isOpen={isOpen} onClose={toggle} onDismiss={toggle}>
      {!isSuccess && <MultiSessionsBooking {...props} setIsSuccess={setIsSuccess} />}
      {isSuccess && <BookingConfirmation toggle={toggle} />}
    </Modal>
  )
}

export default BookMultipleSessionsBlock
